import { useMemo } from "react";
import { GmailLabel } from "@/components/Badges";
import { EnvelopeSimple, CalendarBlank } from "@phosphor-icons/react";

export function GmailInbox({ emails = [] }) {
  const sortedEmails = useMemo(() => {
    return [...emails].sort((a, b) => {
      const da = new Date(a.date || a.created_at || 0).getTime();
      const db = new Date(b.date || b.created_at || 0).getTime();
      return db - da;
    });
  }, [emails]);

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  return (
    <div className="animate-fadein space-y-3" data-testid="gmail-inbox">
      {sortedEmails.length === 0 && (
        <div className="bg-white rounded-md border border-slate-200 p-12 text-center text-slate-400 shadow-sm">
          <EnvelopeSimple size={36} className="mx-auto mb-2 text-slate-300" />
          <p className="font-medium text-slate-600">Bandeja de entrada sincronizada</p>
          <p className="text-xs text-slate-400 mt-1">
            Los emails recibidos en <code>facturacion@cocoand.com</code> aparecerán aquí ordenados por fecha de llegada.
          </p>
        </div>
      )}

      {sortedEmails.map((e) => (
        <div
          key={e.id || e.message_id}
          data-testid={`email-${e.message_id}`}
          className="bg-white rounded-md border border-slate-200 p-4 flex items-start justify-between gap-4 shadow-sm hover:border-slate-300 transition-colors"
        >
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-slate-900 truncate">{e.subject || "(Sin asunto)"}</span>
            </div>
            <div className="text-xs text-slate-500 font-mono mt-0.5">{e.from}</div>
            {e.body && (
              <div className="text-xs text-slate-600 mt-1.5 line-clamp-2 bg-slate-50 p-2 rounded border border-slate-100 font-sans">
                {e.body}
              </div>
            )}
          </div>

          <div className="flex flex-col items-end gap-1.5 shrink-0 text-right">
            <div className="text-[11px] font-medium text-slate-500 flex items-center gap-1">
              <CalendarBlank size={12} className="text-slate-400" />
              {formatDate(e.date || e.created_at)}
            </div>
            <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">
              {e.channel || "adjunto"}
            </span>
            <div className="flex items-center gap-1 mt-0.5">
              {(e.labels || []).length === 0 ? (
                <span className="text-[10px] text-slate-300">sin etiqueta</span>
              ) : (
                e.labels.map((l) => <GmailLabel key={l} label={l} />)
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
